import { localizeIt } from "components/service/localize";
import { UserHelpers } from "components/user";
import Exhibition from "components/exhibition";
import cache from "graphql/cache";

const { permission } = UserHelpers;


const craftTypeTranslations = {
    "logistics"    : { key: "CRAFT.Type_Logistics", params: { number: "" } },
    "logistics_2"  : { key: "CRAFT.Type_Logistics", params: { number: "2" } },
    "logistics_3"  : { key: "CRAFT.Type_Logistics", params: { number: "3" } },
    "floor"        : { key: "CRAFT.Type_Floor", params: { number: "" } },
    "floor_2"      : { key: "CRAFT.Type_Floor", params: { number: "2" } },
    "floor_3"      : { key: "CRAFT.Type_Floor", params: { number: "3" } },
    "assembly"     : { key: "CRAFT.Type_Assembly", params: { number: "" } },
    "assembly_2"   : { key: "CRAFT.Type_Assembly", params: { number: "2" } },
    "assembly_3"   : { key: "CRAFT.Type_Assembly", params: { number: "3" } },
    "electrics"    : { key: "CRAFT.Type_Electrics", params: { number: "" } },
    "electrics_2"  : { key: "CRAFT.Type_Electrics", params: { number: "2" } },
    "electrics_3"  : { key: "CRAFT.Type_Electrics", params: { number: "3" } },
    "graphic"      : { key: "CRAFT.Type_Graphic", params: { number: "" } },
    "graphic_2"    : { key: "CRAFT.Type_Graphic", params: { number: "2" } },
    "graphic_3"    : { key: "CRAFT.Type_Graphic", params: { number: "3" } },
    "furniture"    : { key: "CRAFT.Type_Furniture", params: { number: "" } },
    "furniture_2"  : { key: "CRAFT.Type_Furniture", params: { number: "2" } },
    "furniture_3"  : { key: "CRAFT.Type_Furniture", params: { number: "3" } },
    "multimedia"   : { key: "CRAFT.Type_Multimedia", params: { number: "" } },
    "multimedia_2" : { key: "CRAFT.Type_Multimedia", params: { number: "2" } },
    "multimedia_3" : { key: "CRAFT.Type_Multimedia", params: { number: "3" } },
    "cleaning"     : { key: "CRAFT.Type_Cleaning", params: { number: "" } },
    "cleaning_2"   : { key: "CRAFT.Type_Cleaning", params: { number: "2" } },
    "cleaning_3"   : { key: "CRAFT.Type_Cleaning", params: { number: "3" } },
    "additional"   : { key: "CRAFT.Type_Additional", params: { number: "" } },
    "additional_2" : { key: "CRAFT.Type_Additional", params: { number: "2" } },
    "additional_3" : { key: "CRAFT.Type_Additional", params: { number: "3" } },
    "mp_control"   : { key: "CRAFT.Type_MPControl" },
    "protocol"     : { key: "CRAFT.Type_Protocol" },
    "service"      : { key: "CRAFT.Type_Service", params: { number: "" } },
    "service_2"    : { key: "CRAFT.Type_Service", params: { number: "2" } },
    "service_3"    : { key: "CRAFT.Type_Service", params: { number: "3" } },
    "collect_graphics" : { key: "CRAFT.Type_CollectGraphics" }
};

const getTypeLocalizeParams = (type) => {

    if(type === "damage"){
        return {
            key    : "DAMAGE.AsCraft_label",
            params : {}
        };
    }

    if(!craftTypeTranslations[type]) return null;

    return {
        key    : craftTypeTranslations[type].key,
        params : craftTypeTranslations[type].params || {}
    };
}


const craftTypes = (type) => {

    const craftTypes = {};

    for(let [ key, item ] of Object.entries(craftTypeTranslations)){
        craftTypes[key] = localizeIt(item.key, item.params || {});
    }

    return type ? craftTypes[type] : craftTypes;
}


const existCraftList = (crafts) => {

    const readyCrafts = [];

    for (let [key, value] of Object.entries(craftTypes())) {

        crafts.forEach( ({ type }) => {
            if(type === key){
                readyCrafts.push({
                    "type" : key,
                    "label" : value
                })
            }
        })
    }

    return readyCrafts;
}

const activeCraftList = ({ crafts, stand, varParams }) => {

    const { Helpers : { EE } } = Exhibition;
    const { damage } = stand;

    let activeCrafts = crafts.filter(
        ({ status } ) => [ "disabled" ].indexOf(status) === -1
    );

    if( permission().has({ type: "sub_view" }) ){

        activeCrafts = activeCrafts.filter(
            ({ subcontractor_id } ) =>  permission().equalSubId( subcontractor_id )
        );

    }

    if( EE.damageOldOrNew(varParams) === "new"){
        activeCrafts.push({
            "id"        : damage.id,
            "type"      : "damage",
            "title"     : localizeIt("DAMAGE.AsCraft_label"),
            "status"    : damage.status === "delete" ? "delete" : damage.status,
            "count"     : damage.total_files,
            "craft_jobs": [
                { id: damage.id, type : `damage_${ damage.status }` }
            ],
            "stand_id"  : stand.id
        })


        if(damage.id > 0){
            cache.modify({
                id: cache.identify({ __typename: 'Stand', id: stand.id }),
                fields: {
                    damageReport() {
                        return {...damage};
                    }
                }
            });
        }

    }

    return activeCrafts;
}


const CraftTypeHelper = {
    active : activeCraftList,
    exist  : existCraftList,
    list   : craftTypes,
    localizeParams : getTypeLocalizeParams
}

export default CraftTypeHelper;
